import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter, withRouterConfig } from '@angular/router';
import { APP_ROUTES } from './app/app-routes';
import { ErrorHandler, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from './environments/environment';
import {
  AppConfig,
  DEFAULT_APP_CONFIG,
  ELocale,
  MyAppModule,
} from '@app-utils';
import packageJson from '../../../package.json';
import { HttpBackend, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppTranslationLoader } from '../../utils/src/lib/models/translation';
// import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { Chart, registerables } from 'chart.js';
import {
  ChoroplethController,
  ColorScale,
  GeoFeature,
  ProjectionScale,
} from 'chartjs-chart-geo';

Chart.register(
  ...registerables,
  ChoroplethController,
  GeoFeature,
  ColorScale,
  ProjectionScale,
);

const APP_CONFIG_WITH_DEFAULTS: AppConfig = {
  ...DEFAULT_APP_CONFIG,
  ...environment,
  version: packageJson.version,
};

class DebugErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error('🔥 FULL ERROR:', error);

    if (error?.stack) {
      console.error('🔥 STACK TRACE:', error.stack);
    }
  }
}

// const originalMap = Array.prototype.map;
//
// Array.prototype.map = function (...args: any) {
//   try {
//     // @ts-ignore
//     // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
//     return originalMap.apply(this, args);
//   } catch (e) {
//     // @ts-ignore
//     console.error('🔥 ARRAY CONTENT:', this);
//     throw e;
//   }
// } as any;

bootstrapApplication(AppComponent, {
  providers: [
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    importProvidersFrom([
      BrowserAnimationsModule,
      MyAppModule.forRoot(APP_CONFIG_WITH_DEFAULTS),
      HttpClientModule,
      ToastrModule.forRoot(),

      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: AppTranslationLoader,
          deps: [HttpBackend],
        },
        defaultLanguage: ELocale.ENGLISH_GB,
      }),
    ]),
    provideRouter(
      APP_ROUTES,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
    // { provide: ErrorHandler, useClass: DebugErrorHandler }
  ],
}).catch((err) => console.error(err));
